import getProductsOfInterest from './ProductsOfInterest';
import axios from 'axios';

export default function (vehicle) {
    return new Promise((resolve, reject) => {
        // Try to collect finance from session storage cache
        let cachedFinanceParams = sessionStorage.getItem('used.finance.params.' + vehicle.id);
        if (cachedFinanceParams !== null) {
            try {
                // If we're able to parse what's stored, resolve the promise with it
                resolve(JSON.parse(cachedFinanceParams));
                return;
            } catch (error) {
                console.error(error);
            }
        }

        // If we got this far, then we were unable to get finance params from cache
        // Build the JSON request data for this vehicle
        let json = {
            Credentials: {
                ApiKey: "ONH75GHd8x0gu6yfJ6",
            },
            PhysicalVehicleIdentifier: {
                Identifier: vehicle.id,
                Type: "ExternalVehicleId",
            }
        };

        // POST the data to Codeweavers
        axios({
            method: 'POST',
            url: 'https://services.codeweavers.net/api/finance/defaults',
            headers: {
                'X-CW-ApiKey': 'ONH75GHd8x0gu6yfJ6',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            },
            data: json
        }).then(response => {
            // Convert the response into an easier to use format for Vue to react to
            // If there's an error, reject all finance
            if (typeof response.data.Error != 'undefined' && response.data.Error == true) {
                sessionStorage.setItem('used.finance.params.' + vehicle.id, JSON.stringify({}));
                reject();
                return;
            }

            // Create a blank array to hold the converted result
            let convertedFinanceParams = [];
            let financeKeysOfInterest = getProductsOfInterest(vehicle);

            // Step through each product in the response
            response.data.Products.forEach(cwProduct => {
                let keyIsOfInterest = false;
                for (let index = 0, len = financeKeysOfInterest.length; index < len; index++) {
                    if (financeKeysOfInterest[index].key.toLowerCase() == cwProduct.Key.toLowerCase()) {
                        keyIsOfInterest = financeKeysOfInterest[index];
                    }
                }

                // We don't want every key, so filter out those that aren't needed
                if (!keyIsOfInterest) {
                    return;
                }

                // Build a smaller object with only the information we're interested in
                let dataOfInterest = {
                    key: keyIsOfInterest.key,
                    name: keyIsOfInterest.name,
                    shortName: keyIsOfInterest.shortName,
                    longName: keyIsOfInterest.longName,
                    unavailable: false,
                    defaultTerm: keyIsOfInterest.defaultTerm,
                    defaultMileage: keyIsOfInterest.defaultMileage,
                    defaultDeposit: keyIsOfInterest.defaultDeposit,
                    terms: cwProduct.Term.Values,
                    deposit: {
                        min: cwProduct.Deposit.Minimum,
                        max: cwProduct.Deposit.Maximum,
                    },
                    payment: {
                        min: cwProduct.Payment.Minimum,
                        max: cwProduct.Payment.Maximum,
                    },
                    order: keyIsOfInterest.order
                };

                // Only add mileage if key needs it
                if (keyIsOfInterest.mileage) {
                    dataOfInterest.mileage = cwProduct.AnnualMileage.Values;
                }
                convertedFinanceParams.push(dataOfInterest);
            });

            // Sort the converted array by the order key
            window.testing = convertedFinanceParams;
            convertedFinanceParams.sort(function (a, b) {
                return a.order - b.order;
            });

            // We need to add back in missing keys with a flag that notes them as missing
            // First we'll build an array of the missing keys
            // We then sort the array by the order key, and then push each element back into the convertedFinanceParams object, so we end up with available products ordered correctly first, and then unavailable products ordered by the same rule
            let unavailableKeys = [];
            for (let index = 0, len = financeKeysOfInterest.length; index < len; index++) {
                // if the key isn't set to always show, then we don't show it when no finance is available and we can skip this item immediately
                if (financeKeysOfInterest[index].alwaysShow == false) {
                    continue;
                }
                // Step through the response Products and see if the key had a result or not
                let keyIsPresent = false;
                response.data.Products.forEach(cwProduct => {
                    if (financeKeysOfInterest[index].key.toLowerCase() == cwProduct.Key.toLowerCase()) {
                        keyIsPresent = financeKeysOfInterest[index];
                    }
                });
                // If the key was present, then we have a quote for it and can skip to the next key
                if (keyIsPresent) {
                    continue;
                }

                let unsetFinanceKeyToAdd = {
                    key: financeKeysOfInterest[index].key,
                    name: financeKeysOfInterest[index].name,
                    shortName: financeKeysOfInterest[index].shortName,
                    longName: financeKeysOfInterest[index].longName,
                    unavailable: true,
                    defaultTerm: financeKeysOfInterest[index].defaultTerm,
                    defaultMileage: financeKeysOfInterest[index].defaultMileage,
                    defaultDeposit: financeKeysOfInterest[index].defaultDeposit,
                    deposit: financeKeysOfInterest[index].fallbackDeposit,
                    terms: financeKeysOfInterest[index].fallbackTerms,
                    order: financeKeysOfInterest[index].order,
                };

                if (financeKeysOfInterest[index].mileage) {
                    unsetFinanceKeyToAdd.mileages = financeKeysOfInterest[index].fallbackMileages;
                }

                unavailableKeys.push(unsetFinanceKeyToAdd);
            }

            // If we have unavailable keys, push them onto the end of convertedFinanceParams
            if (convertedFinanceParams.length == 0 && unavailableKeys.length > 0) {
                for (let index = 0, len = unavailableKeys.length; index < len; index++) {
                    convertedFinanceParams.push(unavailableKeys[index]);
                }
            }

            // Store the converted response in session storage so next time the vehicle is viewed this part can be skipped
            // sessionStorage.setItem('used.finance.params.' + vehicle.id, JSON.stringify(convertedFinanceParams));
            // Resolve the request with the data
            resolve(convertedFinanceParams);
        }).catch(error => {
            // Reject if we were unable to get finance data from Codeweavers
            reject(error);
        });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/finance/GetFinanceParameters.js